import { defineComponent } from "vue";
import LiveScene from "./LiveScene";
import FlightModel from "./flight/FlightModel";
import { liveStore } from "../../store//LiveStore";
import StateSvg from "@common/vue/StateSvg.vue";
import LoadingIndicator from "@common/vue/LoadingIndicator.vue";
import { SET_IS_FLIGHT_FOCUS } from "@live/store/LiveMutations";
import { SET_CURRENT_AIRPORT_BY_INDEX, SET_CURRENT_FLIGHT_BY_INDEX } from "@live/store/LiveActions";
export default defineComponent({
    bounceResizeId: null,
    scene: null,
    flightModel: new FlightModel(),
    components: {
        StateSvg,
        LoadingIndicator
    },
    props: {
        flights: {
            type: Object,
        },
        airports: {
            type: Object,
        },
        currentFlight: {
            type: Object,
        },
        isTargetingFlight: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isServerFlightsLoading: function () {
            const isServerFlightsLoading = liveStore.getters.getIsServerDetailLoading;
            return isServerFlightsLoading;
        },
    },
    watch: {
        flights: function (newFlights) {
            this.updateFlights(newFlights);
        },
        airports: function (newAirports) {
            this.updateAirports(newAirports);
        },
        currentFlight: function (newFlight) {
            const scene = this.$options.scene;
            if (scene == null) {
                console.error("Could not refresh route (null LiveScene)");
                return;
            }
            scene.refreshRoutes(newFlight);
        },
        isTargetingFlight: function () {
            const scene = this.$options.scene;
            if (scene == null) {
                console.error("Could not refresh route (null LiveScene)");
                return;
            }
            const flight = liveStore.getters.getCurrentFlightSimple;
            if (flight == null) {
                return;
            }
            scene.target(flight.theta, flight.phi);
        }
    },
    methods: {
        onClickCanvas: function (e) {
            const scene = this.$options.scene;
            if (scene == null) {
                console.error("Could not comsumate onClickCanvas properly (null LiveScene)");
                return;
            }
            const indexFlight = scene.onClickFlights(e);
            const indexAirport = scene.onClickAirports(e);
            if (indexAirport != null) {
                liveStore.commit(SET_IS_FLIGHT_FOCUS, false);
                liveStore.dispatch(SET_CURRENT_AIRPORT_BY_INDEX, { index: indexAirport });
                return;
            }
            if (indexFlight != null) {
                liveStore.commit(SET_IS_FLIGHT_FOCUS, true);
                liveStore.dispatch(SET_CURRENT_FLIGHT_BY_INDEX, { index: indexFlight });
                return;
            }
        },
        onResize() {
            const scene = this.$options.scene;
            if (scene == null) {
                console.error("Could not comsumate onResize properly (null LiveScene)");
                return;
            }
            const bounceResizeId = this.$options.bounceResizeId;
            if (bounceResizeId != null) {
                window.clearTimeout(bounceResizeId);
            }
            this.$options.bounceResizeId = window.setTimeout(() => scene.updateSize(), 1000);
        },
        onKeyUp: function (event) {
            if (event.code === 'Space') {
                this.toggleXRay();
            }
        },
        toggleXRay: function () {
            const scene = this.$options.scene;
            if (scene == null) {
                console.error("Could not comsumate toggleXRay properly (null LiveScene)");
                return;
            }
            scene.toggleXRay();
        },
        onClickZoomIn: function () {
            const scene = this.$options.scene;
            if (scene == null) {
                console.error("Could not comsumate onClickZoomIn properly (null LiveScene)");
                return;
            }
            scene.zoomIn();
        },
        onClickZoomOut: function () {
            const scene = this.$options.scene;
            if (scene == null) {
                console.error("Could not comsumate onClickZoomOut properly (null LiveScene)");
                return;
            }
            scene.zoomOut();
        },
        onClickXRay: function () {
            this.toggleXRay();
        },
        onClickMap: function () {
            this.$emit("onClickMap");
        },
        updateFlights: function (flights) {
            const scene = this.$options.scene;
            if (scene == null) {
                console.error("Could not update flights (null LiveScene)");
                return;
            }
            scene.refreshFlights(flights.map(({ theta, phi, speed, psi, role }) => {
                return {
                    position: { r: 1, theta, phi },
                    speed: { value: speed, psi },
                    role
                };
            }));
        },
        updateAirports: function (airports) {
            const scene = this.$options.scene;
            if (scene == null) {
                console.error("Could not update airports (null LiveScene)");
                return;
            }
            scene.refreshAirports(airports.map(({ theta, phi }) => { return { r: 0, theta, phi }; }));
        }
    },
    mounted: function () {
        const scene = new LiveScene(".universe-canvas");
        this.$options.scene = scene;
        if (this.flights != undefined || this.flights != null) {
            this.updateFlights(this.flights);
        }
        if (this.airports != undefined || this.airports != null) {
            this.updateAirports(this.airports);
        }
        if (this.currentFlight != undefined) {
            scene.refreshRoutes(this.currentFlight);
        }
        window.addEventListener("resize", this.onResize);
        window.addEventListener("keyup", this.onKeyUp);
    },
    unmounted: function () {
        const scene = this.$options.scene;
        if (scene == null) {
            console.warn("Unmounting Universe with a null LiveScene!");
            return;
        }
        window.removeEventListener("resize", this.onResize);
        window.removeEventListener("keyup", this.onKeyUp);
        scene.destroy();
    },
    emits: ["onClickMap"]
});
